export default __webpack_public_path__ + "static/media/star-trophy.8d8387bf.png";